/**
 * Contact form: AJAX submit (progressive enhancement — without JS the form
 * posts to admin-post.php and comes back with a status message).
 */
(() => {
	const t = (window.JD && window.JD.i18n) || {};

	document.querySelectorAll('[data-contact-form]').forEach((form) => {
		const status = form.querySelector('[data-contact-status]');
		const button = form.querySelector('[type="submit"]');

		const say = (message, ok) => {
			status.textContent = message;
			status.classList.toggle('is-success', ok);
			status.classList.toggle('is-error', !ok);
		};

		form.addEventListener('submit', async (e) => {
			e.preventDefault();

			const fields = [...form.querySelectorAll('input[required], textarea[required]')];
			fields.forEach((f) => f.setAttribute('aria-invalid', String(!f.checkValidity())));
			const invalid = fields.find((f) => !f.checkValidity());
			if (invalid) {
				invalid.focus();
				say(invalid.validationMessage, false);
				return;
			}

			const label = button.textContent;
			button.disabled = true;
			button.textContent = t.sending || '…';

			try {
				const response = await fetch(window.JD.ajaxUrl, {
					method: 'POST',
					body: new FormData(form),
					credentials: 'same-origin',
				});
				const json = await response.json();
				if (json.success) {
					form.reset();
					fields.forEach((f) => f.removeAttribute('aria-invalid'));
				}
				say(json.data?.message || t.error, Boolean(json.success));
			} catch (err) {
				say(t.error || 'Error', false);
			} finally {
				button.disabled = false;
				button.textContent = label;
			}
		});
	});
})();
